
    <div class="btn-group dropdown-group" 
        dropdown #streetDrop="bs-dropdown" [autoClose]="false">

        <input #streetControl="ngModel" type="text" (focus)="onFocus()" (blur)="onBlur()" (keyup)="streetChanged(streetValue)" [(ngModel)]="streetValue" class="routeInputs inline-block inputShorted" minlength="2" id="strt" name="strt" placeholder="Введіть назву вулиці та виберіть зі списку" autocomplete="off" />

        <ul [hidden]="! ( isShowStreetsList && isCloseStreetsPresent() )"  id="dropdown-triggers-manual" *dropdownMenu class="street-dropdown-menu"
          role="menu" aria-labelledby="button-triggers-manual">
          
            <div role="menuitem" *ngFor="let street of closeStreets">
            
              <button type="button" class="dropdown-item"  id="{{ 'S'+street.STREET_ID }}"
                (click)="selectStreet( street ); isShowStreetsList = false ; streetDrop.hide();"  >
                {{ street.SHORTSTREETTYPE_UA }} {{ street.STREET_UA }} <span *ngIf="street.haveOldStreetName" >({{ street.OLDSTREET_UA }}) </span>
              </button>

            </div>
          
        </ul>

        <button type="button" [disabled]="! isCloseStreetsPresent() " 
          [ngClass]="dropdownButtonClass" 
          class="btn btn-white dropdown-toggle-split  dropButton greyDropdown " 
          (click)=" isShowStreetsList = ! isShowStreetsList ; "
          formnovalidate="formnovalidate" >
            <i class="fas fa-caret-down"></i>
        </button>

    </div>
  
  